import { ReactComponent as AllDocuments } from '@sketch/icons/documents-2-17'
import { ReactComponent as SharedWithMe } from '@sketch/icons/folder-person-17'
import { ReactComponent as LinkLibrary } from '@sketch/icons/link-library-17'
import { ReactComponent as Trash } from '@sketch/icons/trash-empty-17'
import { ReactComponent as FolderClosed } from '@sketch/icons/folder-closed-17'
import { ReactComponent as FolderOpen } from '@sketch/icons/folder-open-17'
import { ReactComponent as MyDraftsProject } from '@sketch/icons/notes-17'
import { ReactComponent as PersonIcon } from '@sketch/icons/person-17'
import { ReactComponent as BellIcon } from '@sketch/icons/misc-notification-17'
import { ReactComponent as GearIcon } from '@sketch/icons/gear-small-17'
import { ReactComponent as Help } from '@sketch/icons/question-mark-17'
import { ReactComponent as Home } from '@sketch/icons/home-17'
import { ReactComponent as MailEnvelope } from '@sketch/icons/mail-envelope-17'
import { ReactComponent as InformationIcon } from '@sketch/icons/information-filled-outline-17'
import { ReactComponent as QuestionMark } from '@sketch/icons/circle-question-mark-button-translucent-17'
import { ReactComponent as SketchLogo } from '@sketch/icons/sketch-logo-16'
import { ReactComponent as Command } from '@sketch/icons/command-17'
import { ReactComponent as ChatIcon } from '@sketch/icons/comment-chat-bubble-17'
import { ReactComponent as Discord } from '@sketch/icons/discord-17'
import { ReactComponent as EmailIcon } from '@sketch/icons/at-email-17'
import { ReactComponent as TemplateIcon } from '@sketch/icons/templates-17'
import { ReactComponent as Money } from '@sketch/icons/money-dollar-16'
import { ReactComponent as ControlIcon } from '@sketch/icons/control-color-whel-17'
import { ReactComponent as Desktop } from '@sketch/icons/device-desktop-17'
import { ReactComponent as Phone } from '@sketch/icons/device-phone-17'
import { ReactComponent as CommunityIcon } from '@sketch/icons/community-b-17'
import { ReactComponent as LockOpen } from '@sketch/icons/lock-open-17'
import { ReactComponent as GroupCircle } from '@sketch/icons/group-circle-16'
import { ReactComponent as Archive } from '@sketch/icons/box-17'
import { ReactComponent as Key } from '@sketch/icons/key-17'
import { ReactComponent as DesignResources } from '@sketch/icons/resources-17'
import { ReactComponent as Extension } from '@sketch/icons/extension-17'
import { ReactComponent as Book } from '@sketch/icons/book-17'

export const icons = {
  AllDocuments,
  SharedWithMe,
  LinkLibrary,
  Trash,
  FolderClosed,
  FolderOpen,
  MyDraftsProject,
  PersonIcon,
  BellIcon,
  GearIcon,
  EmailIcon,
  Help,
  LockOpen,
  Home,
  MailEnvelope,
  InformationIcon,
  QuestionMark,
  SketchLogo,
  Command,
  ChatIcon,
  Discord,
  DesignResources,
  TemplateIcon,
  Money,
  ControlIcon,
  Phone,
  Desktop,
  CommunityIcon,
  GroupCircle,
  Archive,
  Key,
  Extension,
  Book,
}
